<template lang="pug">
  .history-order
    .form-section
      .history-container
        .history-label(:class="color") Version
        div {{ dataOriginal.version }}
      .history-container
        .history-label(:class="color") {{ capitalize(dataOriginal.transaction) }}d by
        shNameUser(v-if="dataOriginal.transaction === 'create'" :dni="dataOriginal.createdBy")
        shNameUser(v-else :dni="dataOriginal.updatedBy")
      .history-container
        .history-label Order English
        div {{ capitalize(dataOriginal.order) }}
      .history-container
        .history-label Person
        div {{ capitalize(dataOriginal.person) }}
      .history-container
        .history-label Article
        div {{ capitalize(dataOriginal.article) }}
      .history-container
        .history-label Design
        div {{ capitalize(dataOriginal.design) }}
      .history-container
        .history-label Colors
        div {{ arrayToString(dataOriginal.colors) }}
      .history-container
        .history-label Sizes Order
        div {{ arrayToString(dataOriginal.sizesOrder) }}
      .history-container
        .history-label Price Unit
        div {{ money(dataOriginal.priceUnit) }}
      .history-container
        .history-label Price Three
        div {{ money(dataOriginal.priceThree) }}
      .history-container
        .history-label Price Wholesaler
        div {{ money(dataOriginal.priceWholesaler) }}
      .history-container
        .history-label Price Sale
        div {{ money(dataOriginal.priceSale) }}
      .history-container
        .history-label Folder
        div {{ dataOriginal.folder }}
      .history-container
        .history-label Subfolder
        div {{ dataOriginal.subfolder }}
      .history-container
        .history-label Images
        div {{ arrayToString(dataOriginal.images) }}
      .history-container
        .history-label Description
        div {{ dataOriginal.description }}
      .history-container
        .history-label Measurements Image
        div {{ dataOriginal.measurementsImage }}
      .history-container
        .history-label Active
        div {{ dataOriginal.active }}
</template>

<script>
import mFilters from '@/mixins/filters'
import shNameUser from '@/components/elements/NameUser'

export default {
  name: 'HistoryOrderWholesaler',

  mixins: [mFilters],

  components: { shNameUser },

  props: {
    dataOriginal: Object,
    color: String
  }
}
</script>

<style lang="stylus">
.history-order
  position relative
  margin 1.4em 0 1.8em 0
</style>



// WEBPACK FOOTER //
// src/components/pages/orderWholesaler/History.vue